"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _lodash = require("lodash");

var _AxiosRetry = _interopRequireDefault(require("./AxiosRetry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Request = /*#__PURE__*/function () {
  function Request(url, logger, withCredentials, headers) {
    _classCallCheck(this, Request);

    _defineProperty(this, "logger", void 0);

    _defineProperty(this, "url", void 0);

    _defineProperty(this, "withCredentials", void 0);

    _defineProperty(this, "axiosInstance", void 0);

    this.url = url;
    this.logger = logger;
    this.axiosInstance = _axios["default"].create({
      withCredentials: withCredentials,
      headers: headers
    });
    new _AxiosRetry["default"](this.axiosInstance, {
      delay: 3000,
      retries: 3
    }).execute();
  }
  /**
  * put request
  * @param {string} path
  * @param {Object} body
  * @returns {object} Promise
  */


  _createClass(Request, [{
    key: "put",
    value: function put(path, body) {
      var _this = this;

      var url = this.url + path;

      if (this.logger) {
        this.logger.info('put request', {
          url: url
        });
      }

      return new Promise(function (resolve, reject) {
        _this.axiosInstance.put(url, body).then(function (response) {
          if (_this.logger) {
            _this.logger.info('success put request', {
              response: response
            });
          }

          return resolve(response.data);
        })["catch"](function (error) {
          if (_this.logger) {
            _this.logger.error('error put request', {
              error: error
            });
          }

          return reject(error);
        });
      });
    }
    /**
    * post request
    * @param {Object} headers
    * @param {string} path
    * @param {Object} body
    * @returns {object} Promise
    */

  }, {
    key: "post",
    value: function post(body, path, headers) {
      var _this2 = this;

      var url = this.url;
      if (path) url = this.url + path;
      if ((0, _lodash.isEmpty)(headers)) headers = {
        'Content-Type': 'application/json'
      };

      if (this.logger) {
        this.logger.info('post request', {
          url: url
        });
      }

      return new Promise(function (resolve, reject) {
        _this2.axiosInstance.post(url, body, headers).then(function (response) {
          if (_this2.logger) {
            _this2.logger.info('success post request', {
              response: response
            });
          }

          return resolve(response.data);
        })["catch"](function (error) {
          if (_this2.logger) {
            _this2.logger.error('error post request', {
              error: error
            });
          }

          return reject(error);
        });
      });
    }
    /**
    * post request
    * @param {string} path
    * @returns {object} Promise
    */

  }, {
    key: "get",
    value: function get(path) {
      var _this3 = this;

      var url = this.url + path;

      if (this.logger) {
        this.logger.info('get request', {
          url: url
        });
      }

      return new Promise(function (resolve, reject) {
        _this3.axiosInstance.get(url).then(function (response) {
          if (_this3.logger) {
            _this3.logger.info('success get request', {
              response: response
            });
          }

          return resolve(response.data);
        })["catch"](function (error) {
          if (_this3.logger) {
            _this3.logger.error('error get request', {
              error: error
            });
          }

          return reject(error);
        });
      });
    }
  }]);

  return Request;
}();

exports["default"] = Request;